import { Link } from "react-router-dom";
import { Store, Layers } from "lucide-react";

// No fake/mock data here — Home is a lightweight landing that routes
// straight into the real, API-backed Shop/Categories pages. There is no
// "featured products" endpoint or flag on the backend (ProductOut has no
// such field), so no "Featured" section is invented here.
export default function Home() {
  return (
    <div className="max-w-3xl mx-auto px-4 py-16 text-center">
      <h1 className="text-2xl sm:text-3xl font-semibold text-neutral-900">Welcome</h1>
      <p className="mt-2 text-sm text-neutral-500">Browse our products — no login required.</p>

      <div className="mt-8 grid sm:grid-cols-2 gap-4">
        <Link
          to="/shop"
          className="rounded-2xl border border-neutral-200 bg-white p-6 flex flex-col items-center gap-2 shadow-sm hover:shadow-md transition-shadow"
        >
          <Store size={22} className="text-neutral-700" />
          <span className="text-sm font-medium text-neutral-900">Shop All Products</span>
        </Link>
        <Link
          to="/categories"
          className="rounded-2xl border border-neutral-200 bg-white p-6 flex flex-col items-center gap-2 shadow-sm hover:shadow-md transition-shadow"
        >
          <Layers size={22} className="text-neutral-700" />
          <span className="text-sm font-medium text-neutral-900">Browse Categories</span>
        </Link>
      </div>
    </div>
  );
}
